import myAxios from "@/utils/request";
export default {
  // 获取案例咨询
  getCaseList(params) {
    return myAxios.post(
      "/api/industrycase/getindustrycasemodelbyselect",
      params
    );
  },
  batchDeleteCase(params) {
    return myAxios.post("/api/industrycase/batchdelete", params);
  }
};
